import { COMMON_ROUTES, ROUTES } from '@/constants';
import i18n from '@/utils/i18n';

export const USER_ROLES = {
  SYS_ADMIN: 'sys_admin',
  ADMINISTRATOR: 'administrator',
  FLEET_MANAGER: 'fleet_manager',
  CLAIMS_CONTACT: 'claims_contact',
};

export type UserRoleType = {
  name: string;
  accessibleRoutes: string[];
};

export const USER_ROLES_NAMES = {
  [USER_ROLES.SYS_ADMIN]: i18n.t('roles.sysAdmin'),
  [USER_ROLES.ADMINISTRATOR]: i18n.t('roles.administrator'),
  [USER_ROLES.FLEET_MANAGER]: i18n.t('roles.fleetManager'),
  [USER_ROLES.CLAIMS_CONTACT]: i18n.t('roles.claimsContact'),
};

export const ROLE_DETAILS = [
  {
    key: USER_ROLES.SYS_ADMIN,
    name: i18n.t('roles.sysAdmin'),
    accessibleRoutes: [
      ...COMMON_ROUTES,
      ROUTES.SELECT_FLEET,
      ROUTES.MANAGE,
      ROUTES.EDIT_DRIVERS,
      ROUTES.INSURANCE,
    ],
  },
  {
    key: USER_ROLES.ADMINISTRATOR,
    name: i18n.t('roles.administrator'),
    accessibleRoutes: [...COMMON_ROUTES, ROUTES.MANAGE, ROUTES.EDIT_DRIVERS],
  },
  {
    key: USER_ROLES.FLEET_MANAGER,
    name: i18n.t('roles.fleetManager'),
    accessibleRoutes: [...COMMON_ROUTES],
  },
  {
    key: USER_ROLES.CLAIMS_CONTACT,
    name: i18n.t('roles.claimsContact'),
    accessibleRoutes: [...COMMON_ROUTES],
  },
];
